import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';

 
export function* GetByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.GET_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetByPartName(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.GET_BY_PART_NAME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* Save(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.CYCLE_COUNT.SAVE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* Delete(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.CYCLE_COUNT.DELETE + "?InventoryCycleCountID=" + data.id, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportToPdf(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.EXPORT_TO_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportToXls(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.EXPORT_TO_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.GET_ID, data, true);
      
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStockPicking(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.GET_STOCK_PICKING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* AddStockPicking(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.CYCLE_COUNT.ADD_STOCK_PICKING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetStockCount(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.STOCK_COUNT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStockPickingList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.GET_STOCK_COUNT_PICKING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStockPickingDetails(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.GET_STOCK_PICKING_DETAILS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStockPickingByPartName(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.GET_STOCK_PICKING_BY_PART, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportPickingToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.EXPORT_PICKING_TO_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}   

export function* ExportPickingToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CYCLE_COUNT.EXPORT_PICKING_TO_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveStockReturn(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.CYCLE_COUNT.SAVE_STOCK_RETURN, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}